
import React, { useState, useEffect } from 'react';
import { getData } from '../../../../../services/library';
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  TextField,
  Card,
  CardContent,
  CardActions,
  Button,
  Divider,
  Zoom,
  InputAdornment
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchIcon from '@mui/icons-material/Search';
import ListaMaterialesPanel from './ListaMaterialesPanel';
import { createTheme, ThemeProvider } from '@mui/material';
import moment from 'moment';

export default function FormAgregarPedido(props) {
  const [reqmaterial] = useState(props.reqmaterial);
  const [materiales, setMateriales] = useState([]);
  const [openLista, setOpenLista] = useState(false);
  const [datosReq, setDatosReq] = useState({});
  const [selectedReq, setSelectedReq] = useState(null);
  const [search, setSearch] = useState('');

  const obtenerReq = () => {
    getData('/requerimientos_materiales/reqpanelcompras/' + reqmaterial.id, (data) => {
      setMateriales(data);
    }).catch((error) => {
      console.error('Error al obtener requerimientos:', error);
    });
  };

  useEffect(() => {
    obtenerReq();
  }, []);

  const handleClose = () => {
    props.open(false);
    props.tabla(true);
    props.actualizar();
  };

  const dialogListaMateriales = (req) => {
    setSelectedReq(req);
    setOpenLista(true);
    setDatosReq({
      uuid_requerimiento: req.uuid_requerimiento,
      idrequerimiento: req.idrequerimiento,
      uuid_requerimiento_original: reqmaterial.uuid_requerimiento,
    });
  };

  const theme = createTheme({
    palette: {
      primary: { main: '#1976D2' },
      background: { default: '#F5F5F5' },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
      h6: { fontWeight: 500 },
    },
    components: {
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            marginBottom: 16,
            transition: 'transform 0.2s',
            '&:hover': { transform: 'scale(1.02)' },
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Drawer
        anchor="right"
        open={true}
        onClose={handleClose}
        sx={{ '& .MuiDrawer-paper': { width: { xs: '100%', md: '40%' }, p: 2 } }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <IconButton onClick={handleClose}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, textAlign: 'center' }}>
            Seleccionar Requerimiento
          </Typography>
        </Box>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Buscar por ID o sucursal"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ color: 'text.secondary' }} />
              </InputAdornment>
            ),
          }}
          sx={{ mb: 3 }}
        />
        <Divider />
        <Box sx={{ mt: 2, overflowY: 'auto', maxHeight: '80vh', pr: 1 }}>
          {materiales.length === 0 && (
            <Typography variant="body2" color="text.secondary" align="center">
              No hay requerimientos pendientes o parciales para mostrar.
            </Typography>
          )}
          {materiales
            .filter((mat) =>
              String(mat.idrequerimiento).includes(search) ||
              mat.nombre_sucursal?.toLowerCase().includes(search.toLowerCase())
            )
            .map((mat) => (
              <Card key={mat.idrequerimiento} onClick={() => dialogListaMateriales(mat)}>
                <CardContent>
                  <Typography variant="subtitle1" color="primary">
                    Requerimiento #{mat.idrequerimiento}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Sucursal: {mat.nombre_sucursal || 'N/A'}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Fecha: {moment(mat.fecha).format('DD/MM/YYYY')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Estado: {mat.estado === 50 ? 'Pendiente' : mat.estado === 313 ? 'Parcial' : 'Desconocido'}
                  </Typography>
                </CardContent>
              </Card>
            ))}
        </Box>
        {openLista && (
          <ListaMaterialesPanel
            open={setOpenLista}
            datos={datosReq}
            uuid={props.uuid}
            actualizar={() => props.actualizar([selectedReq])}
            obtenerReq={obtenerReq}
          />
        )}
      </Drawer>
    </ThemeProvider>
  );
}
